import React from 'react'
import { Box, get } from '@ally/metronome-ui'
import styled from 'styled-components'

interface LastRowProps {
  alignment: string
  accountId?: string
  children: any
}

const StyledRow = styled(Box)`
  ${get.media.up('md')} {
    padding: ${get.space('sm')};
    text-align: center;
    border-bottom: solid 1px ${get.colors('gray-300')};
  }
`

export const LastRowBox: React.FC<LastRowProps> = ({
  alignment,
  accountId,
  children,
}) => {
  return (
    <StyledRow
      display="flex"
      alignItems={alignment}
      justifyContent={alignment}
      p="xs"
      backgroundColor="white"
      id={`${accountId}-add-bene-success-focus`}
    >
      {children}
    </StyledRow>
  )
}
